export default __webpack_public_path__ + "static/1.10-Label-Inputs-DO-3aee018417ed90e7c4bf074a04a40d2e.png";